import React from 'react';

/**
 * Renders a translated string whose emphasis is marked with **double
 * asterisks**, so translators can move the bold part around the sentence
 * without the markup living in JSX. Emphasis renders as <b>, or as a span
 * with `highlightClassName` when the design styles it differently.
 */
export default function RichText({ text, highlightClassName }) {
    return String(text).split('**').map((part, i) => {
        if (i % 2 === 0) return <React.Fragment key={i}>{part}</React.Fragment>;
        return highlightClassName
            ? <span key={i} className={highlightClassName}>{part}</span>
            : <b key={i}>{part}</b>;
    });
}
